import React from 'react';
/**
 * ScreenTest - Provider selection test page.
 *
 * Displays buttons for different providers. Each button redirects to /d with a mtgSession parameter.
 */

// Provider configuration map
const providerConfig: Record<string, string> = {
  provider1: 'U2FsdGVkX19zSL75kwvL9AL3doK1ijR7SNsczzuv05VVAlBECpamXqWBBu86ua9t8s+hg3vM4JvgehGrvvIredStl9JR0bWLTvvgHpr3FObh4ZcxgGvHRTp1PCFytJPS/nCj3WaE2kZo67EjfYvM5Dt3/Cs/whogivs18hs8NsT8eexxtK9ZnhK//Yn/srfgjE9iM/jP5W+sH6SyJfZwG4C7QOQyi2/8/KW1bXmcsDngJ66/5BU+rzvmpu5NjV2AoKGJGukcnsoxNKWkCtzVYw3QtQ8k2m0By1DwfE1lScDFt8tBpSQTRMZ//dIT80EMuoJLCpILuJm9r7ZgUHo/rlEhluYd3zPfcgZbAb3IyrXgcM2SKCO4xTUyVpbhrqCLCL6c2tnXiY4px/CxvNrtUYOi2YGxR45RMd0Je8RNExu5+gn3259xDSTeo49bFaoQwkw1qA8z9ilAqf09M7dFLa6uoutAXa+UsjsALUgbmqfBnUOy6cyuyEl5IZ63zYwtMyGi9xNJSy1s2Coy2YP2WReWL6huzkNSmwJWxQawio5woZHSeJKNf5ywNrDbS0nzncNO8Lrj2Qt8cTBbKunkp51M9WUVLQh+XczN+4urRx0qXk4u4puDZ8t2Ib+GdarnHDDz+SPo0C2wkh3smsH/nfyeoikKtXSBmZdFKMKO56j9PiLN3OduSr6HCOb9nVs9kN8RTGlGV2s1noUn0aZJjz2inaHQeUWXOvK+26Q++lwdS/thcg51EQ2DsKJ74lAgqCaWzOYYQNREe311Si+XjB63Xyh+Y22UK/LTcS3cNV5F1AaNUk9sF9vgcquAECJWy4/jkhfBocc6MH7/F7QSOQ==',
  provider2: 'U2FsdGVkX196kVadpsk3sC0RyccGJyq+5Dk3hjtlESchfxUODhj6QXqt1ccyWPede9qRcKulYoddaycMgmSWMDA6f5/Nra+lIigrV8gO/XM8eRJkyD76I7fHQtiDIZCf0S/DE5WAtfoIJb5cohdXDJYGJvo/mj0cZZcppYBD3w/5/3+NfQLxdu35Rv0d7dei2XD1LzwKEoeN9sLUMlU6BsLKJWIrWbvDiQFCrvA3B0RQ9wdhemHOC6HbPjpjq57JaKM9ouQ2tc+gDQzrCpGkhmaNXFU5rh7h8fWsT8oOxEl9dm1+dH/6WJltLaaAge0YNxy7wyekSfSwAqeIcPU9LRl/2LdnpQlGWBQZQ+wVEzmm9Spqap4+SJutZlRIOwUb+1+f6BjD41U9x9hbXJBjCstwZtDG1oeZVRO9TNB5mbqFVnr1/Vd9ppHOaE6d/KyO0A7WCXQvyptM/S3omjg4Se/vlKW2C1862AKpOIYLDt40xGwN3bySPeIcj50+THWjyeyBXUl+qu8EN+MipvFqqSNPujKcZjqmsXF0qcgq19UreDKnlQIFTFqIOwYIr7XS2IKg2xQrnCaxTbkSBuv0DfwnvqKVu5QvEoMD+3AnurOwsbM2pkKkNIU9uHpcaGOXBwvfJka1oVWbZxzY4vQAIiER7oeZHI3PJUz5Rkbm1PZwL4/LoY/8I9QiMR5BXoA/YBLmzTsZkns6EZofALSTIbgld2jFMAetbMz/ZWHTSTV4zZX6BGBOKR7JejTR/SaP+jBr3S2ntQVULXrZ21JU4akc4cGHw6MgfSsXuhX2vba6RZ6ESR4gNAPoJTK3ikYrwCVByhGj0yyhklzyxjAURA==',
  provider3: 'U2FsdGVkX1/kD0XGStAFs+IZqBdxWWvroiTOro7GaZnd0bw6WXeeyhrzeuuBtF1pu7FVfCd7ZMkMRQR+vqLEF9d5LUokKe9Is7dRkdOLFVVMxb0sKEgAMxgzMmfviPUdNsOQ3lIDa0UbnG9FTnflD+XovnLy+1n6dBe1G7goFpx4sMw54JOHpjDau/MYL94samc+e5c+i+LrirOGW7kmVtBMIx2H2g4X9WDrGPHjOlkiPCJZ3dteKfWNiang9WaQAO2khh3d9lkJHzzL+o7rkRKBLnT2tcB4mvkry6Tyrf6YvT27mJSqcLokRyaGF56etdikyB6Ido+VF0X5yk2edmv8x9T4IjD58nLuP71EEG699tM6u3r0OH5we+D3aCG8L2sQeFezI6ybGcHQOhiU5vSmXi09EnHj6YNkTsAt+MKsbZMUV6ilC9F2MBTva/7mYC6VXAEnfTg0rBaND8BeQNXiwOtK0b2Pk31E75xWs7i/NclWC55Q8BPOZyigRXIfmMPWmcPk5p8GAhF8G6m3KnMNFIw2n88kn6WrHiDqNrjQ8VNofimlkp2fUrgwxm6V+FHeZbL9n4wHGH+VKiw75h4hu6eY8CaHht4wOtR/fxlea2MbFc83Ts8tp6C6VtaBTGJ1S0tXpAlQJbLVwD99GaIoSmcD3LwtrSREo+7uvgwKIKzZvlrzvJR7TA3aaFP+L7G8Cv3thbQlUZGrS6FFh/AA8xjDntY9A29molKT59ol1IX/zPZxEtULj6UFWLWUpOU7Ipll619Xr5d0fvgNnUyfD9vt+sOuDh2kKtoS1HdhbqM4E8hs2KNDhTYOzRreVfRaEM39G8xA+rapCkVRxg==',
  provider4: 'placeholder-session-4',
  provider5: 'placeholder-session-5',
  provider6: 'placeholder-session-6',
};

// Provider display names
const providerNames: Record<string, string> = {
  provider1: 'Adam Gottfried (WA)',
  provider2: 'Jineth Rojas (NV)',
  provider3: 'Bogus (NV)',
  provider4: 'Provider 4',
  provider5: 'Provider 5',
  provider6: 'Provider 6',
};

const ScreenTest: React.FC = () => {
  const handleProviderClick = (providerId: string) => {
    const sessionValue = providerConfig[providerId];
    if (sessionValue) {
      // Use window.location.replace to force a full page reload, which will trigger
      // useStrictLoadingOrder to run and make the /continue API call
      // Use raw value without encoding to match the working URL format (shows +, /, = in address bar)
      window.location.replace('/d?mtgSession=' + sessionValue);
    }
  };

  return (
    <div className="screen-bg">
      <div className="main-content-container">
        <main className="mtg-screen-main" id="main-content">
          <div className="mtg-screen-card">
            <h2 className="mtg-screen-question">Select a Provider</h2>
            <div className="button-container" role="group" aria-label="Provider selection">
              {Object.keys(providerConfig).map((providerId) => (
                <button
                  key={providerId}
                  className="pill-btn-standard"
                  onClick={() => handleProviderClick(providerId)}
                  aria-label={`Select ${providerNames[providerId]}`}
                >
                  {providerNames[providerId]}
                </button>
              ))}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ScreenTest;

